<script>
  import { fly } from "svelte/transition";
  import Quote from "../components/quote.svelte";
  import { pagingStore } from "../stores/paging.js";
  pagingStore.showPrev(true);
  pagingStore.showNext(true);

  import { laraStore } from "../stores/lara.js";
  laraStore.followMouse(true);
  laraStore.setOpacity(1);

  import { stylesBackground, stylesColor } from "../stores/styles.js";
  stylesBackground.set("gray");
  stylesColor.set("black");
</script>

<div class="page">
  <Quote title="Tag 11">
    Qualität ist uns wichtiger als Hektik.<br>Wir schaffen so langsam wie nötig und so schnell wie möglich, um das Potential unserer Freunde und unserer Föderation langfristig auszuschöpfen.
  </Quote>
</div>
